import { Container } from "@mui/material";
import React from "react";

const TrainingRequest = () => {
  return (
    <Container
      maxWidth="xl"
      sx={{ bgcolor: (theme) => theme.palette.background.paper, borderRadius: 4, height: "100dvh" }}
    >
      <iframe
        src="https://driveeai.pipedrive.com/scheduler/Bp415ATA/drivees-advanced-ai-sales-agent"
        title="Pipedrive Scheduler Embed"
        height="100%"
        width="100%"
        style={{
          border: "inherit",
        }}
      />
    </Container>
  );
};

export default TrainingRequest;
